import { Components, Theme } from '@mui/material';

const MuiBackdrop: Components<Theme>['MuiBackdrop'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(20, 19, 19, 0.25)',
    },
  },
};

export default MuiBackdrop;
